import React, { useState, useEffect, useCallback } from 'react';
import HeadSub from '../../../../components/comm/HeadSub';
import AgreeConditionsBox from '../../../../components/box/AgreeConditionsBox';
import style from './NonFaceAgreeConditions.module.css';
import URL from '../../../../constants/url';
import { useLocation, useNavigate } from 'react-router-dom';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import ToastPopup from '../../../../components/comm/ToastPopup';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';

const NonFaceAgreeConditions = () => {

    const navigate = useNavigate();

    const location = useLocation();
    const { state } = location;

    // toast message
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const [policeInfo, setPoliceInfo] = useState({
        title : '',
        children  : ''
    });

    const [policeList, setPoliceList] = useState([])

    // BottomSheet
    const [open, setOpen] = useState(false);

    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        setOpen(false);
    }, []);

    function onDismiss() {
        setOpen(false);
    }

    //체크박스
    const [check1, setCheck1] = useState(false);
    const [check2, setCheck2] = useState(false);
    const [check3, setCheck3] = useState(false);
    const [checkAll, setCheckAll] = useState(false);

    const handleCheckAll = (e) => {
        const checked = e.target.checked;
        setCheck1(checked);
        setCheck2(checked);
        setCheck3(checked);
        setCheckAll(checked);
    };

    const handleCheck1 = () => {
        const newVal = !check1;
        setCheck1(newVal);
        setCheckAll(newVal && check2 && check3);
    };

    const handleCheck2 = () => {
        const newVal = !check2;
        setCheck2(newVal);
        setCheckAll(check1 && newVal && check3);
    };

    const handleCheck3 = () => {
        const newVal = !check3;
        setCheck3(newVal);
        setCheckAll(check1 && check2 && newVal);
    };

    const handleOnAgreeCheck = () => {
        if( check1 && check2 && check3 ) {
            navigate(URL.NONFACE_SIGNUP);

        } else {
            setToastMessage("You must agree to all the terms and conditions to use the service. ");
            setToast(true);
        }
    };

    useEffect(() => {
        //약관 목록 호출
        const getData = async () => {

            const url = `/signup/retrieveHospitalPolicyIdList`;

            await axiosApi.post(url, ["F", "G", "H"])
            .then((res) => {
                if (res.data.resultCode === CODE.RCV_SUCCESS) {
                    setPoliceList(res.data.result.result);
                } else {
                    setToastMessage(res.data.resultMessage);
                    setToast(true);
                }
            })
            .catch(err => {
                console.error("=========> retrieveHospitalPolicyIdList call failed  : ", err);
            })
        }

        getData();

    },[]);

    const handleClickPolicBtn = useCallback((stplatPolicySeCd) => {

        const selectPolice = policeList.find((item) => item.stplatPolicySeCd === stplatPolicySeCd) ?? {};

        const isEmpty = Object.keys(selectPolice).length === 0

        if(!isEmpty) {
            setPoliceInfo({title : selectPolice.stplatPolicySj, children : selectPolice.stplatPolicyCn});
        } else {
            setPoliceInfo({title : '', children : ''});
        }
        setOpen(true);
    },[policeList]);


    return (
        <>
            <HeadSub title="Agreement to Terms" />

                <div id="sub-content" data-layout="white">
                    <div className='inner-wrap' data-padding="30">

                    <div className='animation-2'>
                        <div className={style['top-box']}>
                            <div className={style['main-txt-box']}>
                                <p>To provide safe and convenient home care services, please review and agree to the <b>Careplus</b> Terms and Conditions.</p>
                            </div>
                            <div className={style['sub-txt-box']}>
                                <span>We are committed to protecting your personal information and your rights when using the service.</span>
                            </div>
                        </div>

                        <div className={style['mid-box']}>
                            <div className={style['all-agree-box']}>
                                <div className='chkbox-custom' data-chkbox='basic'>
                                    <input
                                        type="checkbox"
                                        id='all-chk'
                                        checked={checkAll}
                                        onChange={handleCheckAll}/>
                                    <label htmlFor="all-chk">
                                        <div className={style['txt-box']}>
                                        <p>Agree to All</p>
                                        <span>By using the service, you agree to all the terms below.</span>
                                        </div>
                                    </label>
                                </div>

                            </div>
                            <div className={style['require-agree-box']}>
                                <ul>
                                    <li>
                                        <div className='chkbox-custom' data-chkbox='basic'>
                                            <input type="checkbox" id='require-chk1' checked={check1} onChange={handleCheck1}/>
                                            <label htmlFor="require-chk1">
                                                <div className={style['txt-box']}>
                                                <b>&#91;Required&#93;</b> <p>Terms of Service</p>
                                                </div>
                                            </label>
                                        </div>
                                        <button className={style['more-btn']} onClick={() => handleClickPolicBtn('F')}>
                                            <span>View</span>
                                        </button>
                                    </li>
                                    <li>
                                        <div className='chkbox-custom' data-chkbox='basic'>
                                            <input type="checkbox" id='require-chk2' checked={check2} onChange={handleCheck2}/>
                                            <label htmlFor="require-chk2" >
                                                <div className={style['txt-box']}>
                                                <b>&#91;Required&#93;</b> <p>Consent to Collection and Use of Personal Information</p>
                                                </div>
                                            </label>
                                        </div>
                                        <button className={style['more-btn']} onClick={() => handleClickPolicBtn('G')}>
                                            <span>View</span>
                                        </button>
                                    </li>
                                    <li>
                                        <div className='chkbox-custom' data-chkbox='basic'>
                                            <input type="checkbox" id='require-chk3' checked={check3} onChange={handleCheck3}/>
                                            <label htmlFor="require-chk3">
                                                <div className={style['txt-box']}>
                                                <b>&#91;Required&#93;</b> <p>Consent to Provide Personal Information to Third Parties</p>
                                                </div>
                                            </label>
                                        </div>
                                        <button className={style['more-btn']} onClick={() => handleClickPolicBtn('H')}>
                                            <span>View</span>
                                        </button>
                                    </li>
                                </ul>
                            </div>

                        </div>
                    </div>

                        {/* 하단 다음 버튼 영역 :: S */}
                        <div className="bottom-fixed-box">
                            <div className="inner-box">
                                <div className='btn-layout' data-btn-num="1">

                                    <button
                                        className="btn"
                                        data-btn-type="fill-main"
                                        data-btn-size="lg"
                                        onClick={() => handleOnAgreeCheck() }
                                        disabled={!(check1 && check2 && check3)}
                                    >
                                        <span>Next</span>
                                    </button>

                                </div>
                            </div>
                        </div>
                        {/* 하단 다음 버튼 영역 :: E */}


                        <BottomSheet

                            scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                            expandOnContentDrag={false} // 내용 드래그로 확장 방지

                            open={open}
                            onDismiss={onDismiss}
                            snapPoints={({ maxHeight }) => [
                                maxHeight - maxHeight / 10,
                                maxHeight * 0.6,
                              ]}
                            blocking={true}
                            className={style['header-top']}
                            >
                            <AgreeConditionsBox onClose={onDismiss} title={policeInfo.title} children={policeInfo.children}/>
                        </BottomSheet>

                        {/* 토스트 */}
                        {toast && (
                            <ToastPopup
                                setToast={setToast}
                                message={toastMessage}
                                position='center'
                            />
                        )}

                    </div>
                </div>
        </>
    )
}

export default NonFaceAgreeConditions
